import {
    afterNextRender,
    signal,
    type Injector,
    type Signal,
} from '@angular/core';
import { assertInjector } from './assert-injector';

const HOVER_INTERACTION_MEDIA_QUERY = '(hover: hover) and (pointer: fine)';

export function injectSupportsHoverInteraction(
    injector?: Injector
): Signal<boolean> {
    const resolvedInjector = assertInjector(
        injectSupportsHoverInteraction,
        injector
    );
    const isHoverInteractionEnabled = signal(false);

    afterNextRender(
        () => {
            isHoverInteractionEnabled.set(resolveSupportsHoverInteraction());
        },
        { injector: resolvedInjector }
    );

    return isHoverInteractionEnabled.asReadonly();
}

function resolveSupportsHoverInteraction(): boolean {
    const browserWindow = globalThis.window;
    if (!browserWindow?.matchMedia) return false;

    return browserWindow.matchMedia(HOVER_INTERACTION_MEDIA_QUERY).matches;
}
